import React from 'react';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import enSensorTagTooltips from '@intelligence/_locales/en-US/sensorTagTooltips';
import zhSensorTagTooltips from '@intelligence/_locales/zh-CN/sensorTagTooltips';

export interface ISensorTowerTagOption {
  text: string;
  textCN: string;
  value: string;
  tooltip?: string;
}

type TTooltipEntry = string | { tooltip: string; tags?: string[] };

type TLocaleTooltipMap = Record<string, Record<string, TTooltipEntry>>;

type TTooltipLocales = {
  [key: string]: TLocaleTooltipMap;
};

const TOOLTIP_LOCALES: TTooltipLocales = {
  'en-US': enSensorTagTooltips,
  en: enSensorTagTooltips,
  'zh-CN': zhSensorTagTooltips,
  zh: zhSensorTagTooltips,
};

const getLocaleTooltipMap = (locale: string): TLocaleTooltipMap | null => {
  if (locale === LANGUAGE_CN) {
    return TOOLTIP_LOCALES['zh-CN'] || null;
  }
  return TOOLTIP_LOCALES[locale] || TOOLTIP_LOCALES['en-US'] || null;
};

export const attachTagTooltips = (
  filterKey: string | undefined,
  options: ISensorTowerTagOption[],
  locale: string,
): ISensorTowerTagOption[] => {
  if (!filterKey) return options;

  const localeTooltipMap = getLocaleTooltipMap(locale);
  const tooltipByFilter = localeTooltipMap?.[filterKey];
  if (!tooltipByFilter) return options;

  const tooltipLookup: Record<string, string> = {};

  Object.keys(tooltipByFilter).forEach((key) => {
    const entry = tooltipByFilter[key];
    if (typeof entry === 'string') {
      tooltipLookup[key] = entry;
      return;
    }
    const tooltipValue = entry?.tooltip;
    const tags = entry?.tags;
    if (tooltipValue) {
      tooltipLookup[key] = tooltipValue;
    }
    if (Array.isArray(tags)) {
      tags.forEach((tag) => {
        tooltipLookup[tag] = tooltipValue;
      });
    }
  });

  return (options || []).map((option) => {
    const tooltipKey = option?.value || option?.text || option?.textCN;
    const tooltip = tooltipKey ? tooltipLookup[tooltipKey] : undefined;

    return {
      ...option,
      tooltip,
    };
  });
};
